const libraryModel = Backbone.Model.extend({
  defaults: {
    library_name: 'My content',
    content_type: 'Message',
  },
  initialize() {
    this.defaults.library_name = window.lookup('My content');
  },
  sync(method, model, options) {
    const library = {};

    library.library_name = model.attributes.library_name;

    if (typeof model.attributes.consumerList !== 'undefined') {
      delete library.consumerList;
      library.consumers = model.attributes.consumerList;
    }

    if (typeof model.attributes.contributorList !== 'undefined') {
      delete library.contributorList;
      library.contributors = model.attributes.contributorList;
    }

    if (typeof model.attributes.id !== 'undefined') {
      delete library.id;
      library.content_library_id = model.attributes.id;
    }

    /*            if(typeof model.attributes.user_id !== "undefined"){
            library.user_id = model.attributes.user_id;
        } */

    // Possible methods: create, read, update, dete
    if (method == 'update') {
      return Sendible.Connect.saveLibrary(
        window.appConfig.applicationId,
        $username,
        $password,
        library,
        (result) => {
          options.success(result);
          // model.trigger('sync', model, result, options);
        },
        () => {
        },
      );
    } if (method == 'create') {
      return Sendible.Connect.saveLibrary(
        window.appConfig.applicationId,
        $username,
        $password,
        library,
        (result) => {
          options.success(result);
          // model.trigger('sync', model, result, options);
        },
        () => {
        },
      );
    } if (method == 'delete') {
      Sendible.Connect.deleteLibrary(
        window.appConfig.applicationId,
        $username,
        $password,
        library,
        () => {
          // model.trigger('sync', model, result, options);
        },
        () => {},
      );
    }
  },
});

export default libraryModel;
